export const sentenceTypesPool = [
    {
      sentence: "After the movie ended, we went out for dessert.",
      type: "Complex",
      distractors: ["Compound", "Simple", "Compound-Complex"]
    },
    {
      sentence: "She finished her homework and went to bed.",
      type: "Compound",
      distractors: ["Simple", "Complex", "Compound-Complex"]
    },
    {
      sentence: "The cat slept.",
      type: "Simple",
      distractors: ["Complex", "Compound", "Compound-Complex"]
    },
    {
      sentence: "Although it was raining, we went to the park and played until dark.",
      type: "Compound-Complex",
      distractors: ["Compound", "Complex", "Simple"]
    }
  ];
  